/** @file Update-op handler table: one handler per compiled UpdateOp kind (bone world, IK solve). */
import type { Pose } from '../contracts/pose';
import { solveOneBone } from '../ik/solveOneBone';
import { solveTwoBone } from '../ik/solveTwoBone';
import type { SkeletonData, UpdateOp } from '../skeletonData';
import { updateBoneWorld } from './updateBoneWorld';

/** Handler of one compiled update op; `index` is a bone index ('b') or a constraint index ('ik'). */
export type UpdateOpHandler = (pose: Pose, data: SkeletonData, index: number) => void;

/** The kinds of UpdateOp (the first tuple element). */
export type UpdateOpKind = UpdateOp[0];

/**
 * One handler per UpdateOp kind (exhaustive: a new op kind fails typecheck until it has an entry). 'ik' picks the
 * solver by chain length: one bone → solveOneBone, otherwise solveTwoBone; each solver recomputes its own bones.
 */
export const updateOps: { readonly [K in UpdateOpKind]: UpdateOpHandler } = {
  b: updateBoneWorld,
  ik: (pose, data, index) => {
    if (data.ik[index]?.bones.length === 1) solveOneBone(pose, data, index);
    else solveTwoBone(pose, data, index);
  },
};
